import { render, staticRenderFns } from "./load2.vue?vue&type=template&id=8db4c4f2&scoped=true&"
import script from "./load2.vue?vue&type=script&lang=js&"
export * from "./load2.vue?vue&type=script&lang=js&"
import style0 from "./load2.vue?vue&type=style&index=0&id=8db4c4f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db4c4f2",
  null
  
)

export default component.exports